module.exports = __webpack_public_path__ + "img/exclusivo-prime.5817198e.png";